import { Fragment } from "react";
import Grid from "@mui/material/Grid";
import FooterLinks from "UI/footer-common-links/footerModal/footer-links";
import "./auth-footer.scss";

const AuthFooter = () => {
  return (
    <Fragment>
      <div className="loginFooter">
        <Grid
          container
          justifyContent="space-between"
          alignContent="center"
          className="footer-hold"
        >
          <Grid item md={6} xs={12}>
            <p className="copyright fs-14 line-height-20">
              Copyrights © 2022 All Rights Reserved by
              <span className="ppcn fs-16 primary-color"> DriverTok</span>
            </p>
          </Grid>
          <Grid item md={6} xs={12} lg={6} xl={4} className="footerEnd">
            <FooterLinks footerStyle="grey-color cursor-pointer" />
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};
export default AuthFooter;
